import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { useAddBookmarkModal } from "@/react/components/Modals/AddBookmarkModal";
import type { Space } from "@circle-react/types";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { ButtonWithLabel } from "./ButtonWithLabel";
import { ButtonWithTippy } from "./ButtonWithTippy";

export interface AddBookmarkButtonProps {
  space: Space;
  shouldShowLabel?: boolean;
}

export const AddBookmarkButton = ({
  space,
  shouldShowLabel = true,
}: AddBookmarkButtonProps) => {
  const addBookmarkModal = useAddBookmarkModal();
  return (
    <Dropdown
      direction="bottom-start"
      buttonWrapperClassName="flex"
      transitionWrapperClassName="pt-1.5"
      appendTo={document.body}
      button={
        <Dropdown.MenuButton className="!py-0">
          <div
            className={classNames(
              "hover:bg-tertiary text-default hover:text-dark flex cursor-pointer items-center gap-1 rounded-md p-1",
              {
                "pr-2": shouldShowLabel,
              },
            )}
          >
            {shouldShowLabel ? <ButtonWithLabel /> : <ButtonWithTippy />}
          </div>
        </Dropdown.MenuButton>
      }
    >
      <>
        <Dropdown.ItemLink
          onClick={() => addBookmarkModal.show({ space, isFolder: false })}
        >
          <span className="ml-2">{t("spaces.bookmarks.create_link")}</span>
        </Dropdown.ItemLink>
        <Dropdown.ItemLink
          onClick={() => addBookmarkModal.show({ space, isFolder: true })}
        >
          <span className="ml-2">{t("spaces.bookmarks.create_folder")}</span>
        </Dropdown.ItemLink>
      </>
    </Dropdown>
  );
};
